import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Field, FieldArray, formValueSelector } from 'redux-form';
import { WIZARD_FORM_NAME } from '../../constants/common';

import SummaryField from '../fields/SummaryField';
import TagsSummaryField from '../fields/TagsSummaryField';
import ShelvesSummaryField from '../fields/ShelvesSummaryField';
import Heading from '../elements/PageHeading';
import { getIcon, hasOptionalSetting } from '../../utils/deviceTypes';
import { getSWVersion } from '../../utils/index';

const DeviceSummaryPage = ({
  t,
  handleSubmit,
  type,
  subType,
  groups,
  releaseVersion,
  target,
  reprovisionMode,
  CardTerminal,
}) => (
  <React.Fragment>
    <Heading text={t('device_summary.title')} />
    <form onSubmit={handleSubmit}>
      {!reprovisionMode ? null : (
        <Field
          name="ReprovisionMode"
          label={t('reprovision_mode.label')}
          type="text"
          component={SummaryField}
          displayValue={value => t(`reprovision_mode.${value}`)}
        />
      )}
      <Field
        name="Organization"
        label={t('device_organization.label')}
        type="text"
        component={SummaryField}
        displayValue={value => groups.find(o => o.Id === value).Name || value}
      />
      <Field
        name="Type"
        label={t('device_type.label')}
        type="text"
        component={SummaryField}
        getIcon={getIcon}
        displayValue={value => t(`device_type.${value}`)}
      />
      {type === 'smartCabinet' ? (
        <Field
          name="SubType"
          label={t('device_subtype.label')}
          type="text"
          component={SummaryField}
          hide={value => value === 'None'}
          displayValue={value => t(`device_subtype.${value}`)}
        />
      ) : null}
      <Field
        name="Name"
        label={t('device_name.label')}
        type="text"
        component={SummaryField}
      />
      <Field
        name="Id"
        label={t('device_id.label')}
        type="text"
        component={SummaryField}
      />
      {reprovisionMode ? null : (
        <Field
          name="Area"
          label={t('device_country.area')}
          type="text"
          component={SummaryField}
          displayValue={value => value.label}
        />
      )}
      <Field
        name="Country"
        label={t('device_country.label')}
        type="text"
        component={SummaryField}
        displayValue={value => value.label}
      />
      <Field
        name="City"
        label={t('device_city.label')}
        type="text"
        component={SummaryField}
        displayValue={value => value.label}
      />
      <Field
        name="TimeZone"
        label={t('device_timeZone.label')}
        type="text"
        component={SummaryField}
        displayValue={value => value.label}
      />
      <Field
        name="Latitude"
        label={t('device_latitude.label')}
        type="text"
        component={SummaryField}
        displayValue={value => value}
      />
      <Field
        name="Longitude"
        label={t('device_longitude.label')}
        type="text"
        component={SummaryField}
        displayValue={value => value}
      />
      <Field
        name="Description"
        label={t('device_description.label')}
        type="text"
        component={SummaryField}
      />
      {hasOptionalSetting(subType, 'SHELF_COUNT') && (
        <Field
          name="ShelfCount"
          label={t('device_additional.shelf_count_label')}
          type="text"
          component={SummaryField}
        />
      )}

      {hasOptionalSetting(subType, 'CARD_PAYMENT') && (
        <Field
          name="CardTerminal"
          label={t('device_additional.card_payment')}
          type="text"
          component={SummaryField}
        />
      )}
      {CardTerminal === 'Axis-ingenico' && (
        <Field
          name="antenorTPVnr"
          label={t('device_antenor_tpv.label')}
          type="text"
          component={SummaryField}
          displayValue={value => value.label}
        />
      )}
      {CardTerminal === 'wipay' && (
        <Field
          name="wipayTerminalId"
          label={t('wipay_terminal_id.label')}
          type="text"
          component={SummaryField}
          displayValue={value => value.label}
        />
      )}

      <FieldArray name="Tags" component={TagsSummaryField} />
      <SummaryField
        label="Release Version"
        input={{
          value: getSWVersion(releaseVersion, type, subType, target.osVersion),
        }}
        meta={{ error: null }}
      />

      {hasOptionalSetting(subType, 'SHELF_CONFIG') && (
        <FieldArray name="Shelves" component={ShelvesSummaryField} />
      )}
    </form>
  </React.Fragment>
);

const selector = formValueSelector(WIZARD_FORM_NAME);
const mapStateToProps = state => ({
  groups: state.user.user.groups,
  type: selector(state, 'Type'),
  subType: selector(state, 'SubType'),
  releaseVersion: state.device.releaseVersion,
  target: state.device.target ? state.device.devices[state.device.target] : {},
  reprovisionMode: selector(state, 'ReprovisionMode'),
  CardTerminal: selector(state, 'CardTerminal'),
});

export default connect(mapStateToProps)(translate()(DeviceSummaryPage));
